<template>
  <div>
    <!--工具条-->

    <toolbar :buttonList="buttonList" @callFunction="callFunction"></toolbar>

    <div style="display: block">
      <div class="toolBar">
        <el-input
          v-model="filterParams.SearchValue"
          style="width: 200px"
          class="mr12"
        ></el-input>
        <el-date-picker
          v-model="filterParams.StartTime"
          type="datetime"
          class="mr12"
          placeholder="选择开始时间"
        ></el-date-picker>
        <el-date-picker
          v-model="filterParams.EndTime"
          type="datetime"
          class="mr12"
          placeholder="选择结束时间"
        ></el-date-picker>
        <el-button type="primary" size="small" @click="handleSearch"
          >查询</el-button
        >
        <el-button type="primary" size="small" @click="handleReset"
          >重置</el-button
        >
      </div>
    </div>
    <!-- -->
    <div style="margin-top: 12px">
      <el-table
        :data="list"
        v-loading="listLoading"
        style="width: 100%"
        ref="table"
        class="custom-tbl"
        @selection-change="handleChoose"
      >
        <el-table-column type="selection" width="50"></el-table-column>
        <el-table-column label="序号" type="index" width="80"></el-table-column>
        <el-table-column label="场馆名称" prop="VenueName"></el-table-column>
        <el-table-column
          label="订场名称"
          prop="VenueCourtName"
        ></el-table-column>
        <el-table-column
          label="场地名称"
          prop="VenueCourtSiteName"
        ></el-table-column>
        <el-table-column label="开始时间" prop="StartTime"></el-table-column>
        <el-table-column label="结束时间" prop="EndTime"></el-table-column>
        <el-table-column
          label="开始时间（小时）"
          prop="StartHour"
        ></el-table-column>
        <el-table-column
          label="结束时间（小时）"
          prop="EndHour"
        ></el-table-column>
        <!-- <el-table-column
          label="微信用户Id"
          prop="WxUserInfoId"
        ></el-table-column> -->
        <!-- <el-table-column
          label="是否售完"
          prop="IsSoldOut"
          :formatter="formatSoldOut"
        ></el-table-column> -->
        <el-table-column label="操作">
          <template slot-scope="scope">
            <el-button type="plain" size="mini" @click="handleEdit(scope.row)"
              >编辑</el-button
            >
            <el-button type="danger" size="mini" @click="handleDel(scope.row)"
              >删除</el-button
            >
          </template>
        </el-table-column>
      </el-table>
    </div>
    <div>
      <el-pagination
        layout="total, sizes, prev, pager, next, jumper"
        @current-change="handleCurrentChange"
        @size-change="handleSizeChange"
        :current-page="page.page"
        :page-sizes="[10, 20, 30, 40, 50, 100]"
        :page-size="page.intPageSize"
        :total="total"
        style="float: right"
      >
      </el-pagination>
    </div>
    <!--新增界面-->
    <el-dialog
      :title="dialogStatus === 'add' ? '新增' : '编辑'"
      :visible.sync="dialogVisible"
      :close-on-click-modal="false"
      width="800px"
    >
      <el-form
        :model="formData"
        label-width="100px"
        :rules="formRules"
        ref="dataForm"
      >
        <!-- 第一行：场馆、订场 -->
        <el-row :gutter="20">
          <el-col :span="12">
            <el-form-item label="场馆" prop="VenueId">
              <el-select
                v-model="formData.VenueId"
                filterable
                remote
                :remoteMethod="getVenue"
                @change="getCourt()"
                style="width: 100%"
              >
                <el-option
                  v-for="item in venueList"
                  :key="item.Id"
                  :label="item.Name"
                  :value="item.Id"
                ></el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="订场" prop="VenueCourtId">
              <el-select
                :disabled="!formData.VenueId"
                v-model="formData.VenueCourtId"
                filterable
                remote
                :remoteMethod="getCourt"
                @change="getSite()"
                style="width: 100%"
              >
                <el-option
                  v-for="item in courtList"
                  :key="item.Id"
                  :label="item.Name"
                  :value="item.Id"
                ></el-option>
              </el-select>
            </el-form-item>
          </el-col>
        </el-row>

        <!-- 第二行：场地、间隔时间 -->
        <el-row :gutter="20">
          <el-col :span="12">
            <el-form-item label="场地" prop="VenueCourtSiteId">
              <el-select
                :disabled="!formData.VenueCourtId"
                v-model="formData.VenueCourtSiteId"
                filterable
                remote
                :remoteMethod="getSite"
                style="width: 100%"
              >
                <el-option
                  v-for="item in siteList"
                  :key="item.Id"
                  :label="item.Name"
                  :value="item.Id"
                ></el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="间隔时间" prop="Interval">
              <el-input-number
                :min="30"
                :step="1"
                v-model="formData.Interval"
                auto-complete="off"
                style="width: calc(100% - 50px)"
                placeholder="请输入间隔时间（不低于30分钟）"
              ></el-input-number>
              <span style="margin-left: 10px">分钟</span>
            </el-form-item>
          </el-col>
        </el-row>

        <!-- 第三行：开始时间、结束时间 -->
        <el-row :gutter="20">
          <el-col :span="12">
            <el-form-item label="开始时间" prop="StartTime">
              <el-date-picker
                v-model="formData.StartTime"
                placeholder="选择开始时间"
                value-format="yyyy-MM-dd"
                style="width: 100%"
              ></el-date-picker>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="结束时间" prop="EndTime">
              <el-date-picker
                v-model="formData.EndTime"
                value-format="yyyy-MM-dd"
                placeholder="选择结束时间"
                style="width: 100%"
              ></el-date-picker>
            </el-form-item>
          </el-col>
        </el-row>

        <!-- 第四行：开始时长、结束时长 -->
        <el-row :gutter="20">
          <el-col :span="12">
            <el-form-item label="开始时长" prop="StartHour">
              <el-time-picker
                v-model="formData.StartHour"
                placeholder="选择开始时长"
                value-format="HH:mm"
                style="width: 100%"
                :picker-options="{
                  format: 'HH:mm',
                }"
              ></el-time-picker>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="结束时长" prop="EndHour">
              <el-time-picker
                v-model="formData.EndHour"
                placeholder="选择结束时长"
                value-format="HH:mm"
                style="width: 100%"
                :picker-options="{
                  format: 'HH:mm',
                }"
              ></el-time-picker>
            </el-form-item>
          </el-col>
        </el-row>

        <!-- 第五行：价格 -->
        <el-row :gutter="20">
          <el-col :span="12">
            <el-form-item label="价格" prop="Price">
              <el-input-number
                :min="0"
                :step="0.01"
                v-model="formData.Price"
                auto-complete="off"
                style="width: 100%"
              ></el-input-number>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="限制人数" prop="AppointmentCount">
              <el-input-number
                :min="1"
                :step="1"
                v-model="formData.AppointmentCount"
                auto-complete="off"
                style="width: 100%"
              ></el-input-number>
            </el-form-item>
          </el-col>
        </el-row>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="dialogVisible = false">取消</el-button>
        <el-button type="primary" @click="submitForm" :loading="submitLoading"
          >提交</el-button
        >
      </div>
    </el-dialog>
  </div>
</template>
<script>
import { getButtonList } from "../../promissionRouter";
import Toolbar from "../../components/Toolbar";
import {
  getAppointmentList,
  addAppointment,
  deleteAppointment,
  updateAppointment,
  batchDeleteAppointment,
} from "@/api/stadium/appointment";
import {
  getStadiumData,
  getSiteData,
  getCourtData,
} from "@/api/stadium/stadium";
import util from "../../../util/date";

export default {
  components: { Toolbar },
  data() {
    return {
      filterParams: {
        SearchValue: "",
        StartTime: "",
        EndTime: "",
      },
      page: {
        page: 1,
        intPageSize: 10,
      },
      listLoading: false,
      total: 0,
      list: [],
      buttonList: [],
      dialogVisible: false,
      dialogStatus: "add",
      formData: {},
      formRules: {
        VenueId: [{ required: true, message: "请选择场馆", trigger: "change" }],
        VenueCourtId: [
          { required: true, message: "请选择订场", trigger: "change" },
        ],
        VenueCourtSiteId: [
          { required: true, message: "请选择场地", trigger: "change" },
        ],
        Interval: [
          { required: true, message: "请输入间隔时间", trigger: "blur" },
          {
            type: "number",
            min: 30,
            message: "间隔时间不能低于30分钟",
            trigger: "blur",
          },
        ],
        StartTime: [
          { required: true, message: "请选择开始时间", trigger: "change" },
        ],
        EndTime: [
          { required: true, message: "请选择结束时间", trigger: "change" },
        ],
        StartHour: [
          { required: true, message: "请选择开始时长", trigger: "change" },
        ],
        EndHour: [
          { required: true, message: "请选择结束时长", trigger: "change" },
        ],
        Price: [{ required: true, message: "请输入价格", trigger: "blur" }],
        AppointmentCount: [
          { required: true, message: "请输入限制人数", trigger: "blur" },
        ],
      },
      submitLoading: false,
      venueList: [],
      courtList: [],
      siteList: [],
      idList: [],
    };
  },
  created() {
    let routers = window.localStorage.router
      ? JSON.parse(window.localStorage.router)
      : [];
    this.buttonList = getButtonList(this.$route.path, routers);
    this.getList();
    this.getVenue();
    this.getSite();
  },
  methods: {
    mulDelete() {
      this.$confirm("确认删除该记录吗?", "提示", {
        type: "warning",
      }).then(() => {
        batchDeleteAppointment({
          ListId: this.idList,
        }).then((res) => {
          if (res.data.success) {
            this.initPage();
            this.$message({
              message: "删除成功",
              type: "success",
            });
          } else {
            this.$message({
              message: res.data.msg,
              type: "error",
            });
          }

          this.getList();
        });
      });
    },
    handleChoose(e) {
      console.log(e);
      this.idList = e.map((item) => item.Id);
    },
    handleAdd() {
      this.dialogStatus = "add";
      this.dialogVisible = true;
      this.formData = {
        AppointmentCount: 1,
      };
      this.$nextTick(() => {
        this.$refs["dataForm"].clearValidate();
      });
    },
    handleEdit(row) {
      this.dialogStatus = "edit";
      this.dialogVisible = true;
      this.getSite("", row.VenueCourtId);
      this.getCourt("", row.VenueId);
      this.formData = Object.assign({}, row);
      this.$nextTick(() => {
        this.$refs["dataForm"].clearValidate();
      });
    },
    handleDel(row) {
      this.$confirm("确认删除该记录吗?", "提示", {
        type: "warning",
      }).then(() => {
        deleteAppointment({
          Id: row.Id,
        }).then((res) => {
          if (res.data.success) {
            this.initPage();
            this.$message({
              message: "删除成功",
              type: "success",
            });
            this.getList();
          } else {
            this.$message({
              message: res.data.msg,
              type: "error",
            });
          }
        });
      });
    },
    getSite(val = "", Id = this.formData.VenueCourtId) {
      if (!Id) return;
      getSiteData({
        Id: Id,
        key: val,
      }).then((res) => {
        this.siteList = res.data.response;
      });
    },
    getVenue(val = "") {
      getStadiumData({
        key: val,
      }).then((res) => {
        this.venueList = res.data.response;
      });
    },
    getCourt(val = "", Id = this.formData.VenueId) {
      if (!Id) return;
      getCourtData({
        Id: Id,
        key: val,
      }).then((res) => {
        this.courtList = res.data.response;
      });
    },
    handleCurrentChange(val) {
      this.page.page = val;
      this.getList();
    },
    handleSizeChange(val) {
      this.page.intPageSize = val;
      this.getList();
    },
    initPage() {
      this.page.page = 1;
      this.page.intPageSize = 10;
      this.filters = {
        name: "",
      };
    },
    handleSearch() {
      this.initPage();
      this.getList();
    },
    handleReset() {
      this.filterParams = {
        SearchValue: "",
        StartTime: "",
        EndTime: "",
      };
      this.initPage();
      this.getList();
    },
    getList() {
      let params = { ...this.filterParams, ...this.page };
      this.listLoading = true;
      getAppointmentList(params)
        .then((res) => {
          this.total = res.data.response.dataCount;
          this.list = res.data.response.data;
          this.listLoading = false;
        })
        .catch(() => {
          this.listLoading = false;
        });
    },
    callFunction(item) {
      this.filters = {
        name: item.search,
      };
      this[item.Func].apply(this, item);
    },
    submitForm() {
      this.$refs.dataForm.validate((valid) => {
        if (valid) {
          this.submitLoading = true;
          const data = Object.assign({}, this.formData);
          const request =
            this.dialogStatus === "add" ? addAppointment : updateAppointment;

          request(data).then((res) => {
            if (util.isEmt.format(res)) {
              this.submitLoading = false;
              return;
            }
            if (res.data.success) {
              this.submitLoading = false;
              this.$message({
                message: res.data.msg,
                type: "success",
              });
              this.dialogVisible = false;
              this.initPage();
              this.getList();
            } else {
              this.$message({
                message: res.data.msg,
                type: "error",
              });
              this.submitLoading = false;
            }
          });
        }
      });
    },
  },
};
</script>
<style scoped>
.mr12 {
  margin-right: 12px;
}
.toolBar {
  width: 100%;
  display: flex;
  align-items: center;
}
.custom-tbl ::v-deep .has-gutter .el-checkbox {
  display: none;
}
.delBtn {
  color: #db3636;
}
/* 表单label左对齐样式 */
::v-deep .el-form-item__label {
  text-align: left;
  width: 120px;
  padding-right: 20px;
}
</style>
